import { cn } from '@/utils';
import { Outlet } from 'react-router-dom';

const MainLayout = () => {
  return (
    <div className="min-h-screen w-full bg-background text-black">
      {/* Header */}
      <header className="fixed z-40 h-[50px] w-full px-3 bg-primary text-primary-foreground flex items-center border-b border-b-border">
        <a href="/game-list" className="font-card-characters md:px-2">
          Diamond Casino
        </a>
      </header>
      {/* Main outlet */}
      <main className={cn('min-h-screen w-full pt-[50px]')}>
        <Outlet />
      </main>
    </div>
  );
};

export default MainLayout;
